import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Link from 'next/link';

import { setFAQRedirectLoading } from '~/src/features/faq/store/actionCreators';
import { selectActiveCategoryAlias } from '~/src/features/faq/store/selectors';

import * as ST from './styled';

interface IProps {
    articleName: string,
    articleDescription: string,
    articleAlias: string,
}

export const FAQArticlePreview = ({ articleName, articleDescription, articleAlias }: IProps) => {
    const dispatch = useDispatch();
    const activeCategoryAlias = useSelector(selectActiveCategoryAlias);

    return <Link href={`/faq/${activeCategoryAlias}/${articleAlias}`}>
        <ST.Category onClick={() => dispatch(setFAQRedirectLoading(true))}>
            <ST.Content>
                <ST.Title>{articleName}</ST.Title>
                <ST.SubTitle>{articleDescription}</ST.SubTitle>
            </ST.Content>
        </ST.Category>
    </Link>;
};
